"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RulesConf = exports.analyzeRules = void 0;
exports.analyzeDatabase = analyzeDatabase;
exports.scoreDatabase = scoreDatabase;
const zod_1 = require("zod");
const utils_1 = require("@azimutt/utils");
const zod_2 = require("../zod");
const databaseUtils_1 = require("../databaseUtils");
const connector_1 = require("../interfaces/connector");
const rule_1 = require("./rule");
const attributeEmpty_1 = require("./rules/attributeEmpty");
const attributeNameInconsistent_1 = require("./rules/attributeNameInconsistent");
const attributeTypeBad_1 = require("./rules/attributeTypeBad");
const attributeTypeInconsistent_1 = require("./rules/attributeTypeInconsistent");
const entityEmpty_1 = require("./rules/entityEmpty");
const entityGrowFast_1 = require("./rules/entityGrowFast");
const entityIndexNone_1 = require("./rules/entityIndexNone");
const entityIndexTooHeavy_1 = require("./rules/entityIndexTooHeavy");
const entityIndexTooMany_1 = require("./rules/entityIndexTooMany");
const entityNameInconsistent_1 = require("./rules/entityNameInconsistent");
const entityNotClean_1 = require("./rules/entityNotClean");
const entityTooLarge_1 = require("./rules/entityTooLarge");
const entityUnused_1 = require("./rules/entityUnused");
const indexDuplicated_1 = require("./rules/indexDuplicated");
const indexGrowFast_1 = require("./rules/indexGrowFast");
const indexOnRelation_1 = require("./rules/indexOnRelation");
const indexUnused_1 = require("./rules/indexUnused");
const primaryKeyMissing_1 = require("./rules/primaryKeyMissing");
const primaryKeyNotBusiness_1 = require("./rules/primaryKeyNotBusiness");
const queryDegrading_1 = require("./rules/queryDegrading");
const queryExpensive_1 = require("./rules/queryExpensive");
const queryHighVariation_1 = require("./rules/queryHighVariation");
const queryTooSlow_1 = require("./rules/queryTooSlow");
const relationMisaligned_1 = require("./rules/relationMisaligned");
const relationMissAttribute_1 = require("./rules/relationMissAttribute");
const relationMissEntity_1 = require("./rules/relationMissEntity");
const relationMissing_1 = require("./rules/relationMissing");
__exportStar(require("./rule"), exports);
exports.analyzeRules = [
    // hint rules
    attributeTypeInconsistent_1.attributeTypeInconsistentRule,
    queryExpensive_1.queryExpensiveRule,
    queryHighVariation_1.queryHighVariationRule,
    // low rules
    entityEmpty_1.entityEmptyRule,
    attributeEmpty_1.attributeEmptyRule,
    entityNameInconsistent_1.entityNameInconsistentRule,
    attributeNameInconsistent_1.attributeNameInconsistentRule,
    // medium rules
    entityUnused_1.entityUnusedRule,
    indexUnused_1.indexUnusedRule,
    attributeTypeBad_1.attributeTypeBadRule,
    entityGrowFast_1.entityGrowFastRule,
    indexGrowFast_1.indexGrowFastRule,
    entityTooLarge_1.entityTooLargeRule,
    entityIndexTooMany_1.entityIndexTooManyRule,
    entityIndexTooHeavy_1.entityIndexTooHeavyRule,
    primaryKeyNotBusiness_1.primaryKeyNotBusinessRule,
    indexOnRelation_1.indexOnRelationRule,
    relationMissing_1.relationMissingRule,
    // high rules
    indexDuplicated_1.indexDuplicatedRule,
    queryTooSlow_1.queryTooSlowRule,
    queryDegrading_1.queryDegradingRule,
    entityNotClean_1.entityNotCleanRule,
    primaryKeyMissing_1.primaryKeyMissingRule,
    entityIndexNone_1.entityIndexNoneRule,
    relationMisaligned_1.relationMisalignedRule,
    relationMissAttribute_1.relationMissAttributeRule,
    relationMissEntity_1.relationMissEntityRule,
];
exports.RulesConf = zod_1.z.object({
    database: connector_1.ConnectorConfOpts.merge(connector_1.ConnectorScopeOpts).merge(connector_1.ConnectorSchemaDataOpts).strict().optional(),
    rules: zod_1.z.object(Object.fromEntries(exports.analyzeRules.map(r => [r.id, r.zConf.optional()]))).strict().optional(),
}).strict().describe('RulesConf');
// TODO: split rules by kind? (schema, query, data...)
function analyzeDatabase(conf, now, db, queries, history, reference, ruleNames) {
    // TODO: use uuid or bigint for single primary key, not int or varchar ones
    // TODO: use uuidv7 for sorted uuids, not v4
    // TODO: uuids not stored as CHAR(36) => field ending with `id` and with type CHAR(36) => suggest type `uuid`/`BINARY(16)` instead (depend on db)
    // TODO: warn on queries with ORDER BY RAND()
    // TODO: constraints should be deferrable (pk, fk, unique)
    // TODO: tables/columns with incrementing names
    // TODO: columns with no (or very few) null but no NOT NULL constraint => suggest add NOT NULL constraint
    // TODO: columns with all (or mostly) different values but no UNIQUE constraint => suggest to add UNIQUE constraint
    // TODO: columns with all (or mostly) null values => suggest to remove (hint)
    // TODO: columns with mostly the same data as an other one (common values & histogram) => is duplicate? suggest to remove? (hint)
    // TODO: queries not using indexes
    // TODO: JSON columns with different schemas (% of similarity between schemas)
    // TODO: sequence/auto_increment exhaustion
    // TODO: use varchar over char (https://youtu.be/ifEpT5STEU0?si=fcLBuwrgluG9crwt&t=90)
    // TODO: auto_explain: index creation (https://pganalyze.com/docs/explain/setup/self_managed/01_auto_explain_check)
    // TODO: missing relations from JOIN clauses
    // TODO: columns frequently used on JOIN, WHERE and ORDER BY clauses should have an index
    // TODO: monitor index fragmentation
    // TODO: monitor replication lag
    // TODO: alert on deadlocks
    // TODO: suggest partial indexes: when there is often IS NULL or IS NOT NULL on query where clauses
    // TODO: detect n+1 queries?
    // TODO: blocking queries (> 1 min)
    // TODO: special case: soft delete => if deleted_at column, suggest index on `deleted_at IS NULL`
    // TODO: if index on column with many nulls: suggest two indexes: one with values where not null and one is IS NULL (ex: `btree (org_id)` => `btree (org_id) WHERE org_id IS NOT NULL` & `btree (org_id IS NULL) WHERE org_id IS NULL`)
    // TODO: single column indexes on low cardinality column => suggest bitmap index instead
    // TODO: warn queries sans where clause ^^
    // TODO: locks using https://www.postgresql.org/docs/current/view-pg-locks.html
    // TODO: no "SELECT *" query
    const rules = ruleNames.length > 0 ? exports.analyzeRules.filter(r => ruleNames.indexOf(r.id) !== -1 || ruleNames.indexOf(r.name) !== -1) : exports.analyzeRules;
    return Object.fromEntries(rules.map(r => {
        const ruleConf = Object.assign({}, r.conf, conf.rules?.[r.id]);
        return [r.id, (0, zod_2.zodParse)(r.zConf, r.id)(ruleConf).fold(ruleConf => ({
                rule: r,
                conf: ruleConf,
                violations: ruleConf.level === rule_1.RuleLevel.enum.off ? [] : r.analyze(ruleConf, now, db, queries, history, reference?.[r.id]?.violations || [])
            }), err => ({ rule: r, conf: ruleConf, violations: [{ ruleId: r.id, ruleName: r.name, ruleLevel: r.conf.level, message: `Invalid conf: ${err}` }] }))];
    }));
}
// interesting:
// - most used tables (in queries)
// - table growth rate (Go/Month)
// - query slow down rate (ms/month, mean & max)
// - unused tables / indexes
function scoreDatabase(db, violations) {
    // TODO: compute table importance: page rank & data cardinality (other interesting inputs: storage size, nb columns, nb relations, nb queries, nb indexes), use it to weight the overall score
    const violationsByEntity = (0, utils_1.groupBy)(violations, v => v.entity ? (0, databaseUtils_1.entityRefToId)(v.entity) : 'unknown');
    return { score: 0, entities: {} };
}
// safe migration rules:
// - always concurrently in create/drop indexes
// - disable validations at the beginning, enable them at the end (foreign keys, unique, pk, checks...)
// - no default value on add column (will update every row otherwise)
// - drop foreign keys before dropping a table
//# sourceMappingURL=index.js.map